import { render, staticRenderFns } from "./ruPrivacy.vue?vue&type=template&id=7a697339&scoped=true&"
import script from "./ruPrivacy.vue?vue&type=script&lang=js&"
export * from "./ruPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./ruPrivacy.vue?vue&type=style&index=0&id=7a697339&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a697339",
  null
  
)

export default component.exports